import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import Backbone from 'backbone';
import Global from 'models/Global';
import { unmountComponentAtNode } from 'react-dom';
import _ from 'underscore';
import FormViewMixin from 'views/FormViewMixin';
import BootstrapData from 'models/BootstrapData';
import { renderAttendeeLogin } from './reactViews/AttendeeLogin';

var SignUpView = Backbone.View.extend({
    initialize: function(options) {
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.publicWebsiteBaseUrl = Global.get('event').getPublicWebsiteBaseUrl();
        this.siteConf = BootstrapData('bootstrap-data-siteConf');
    },

    remove: function() {
        unmountComponentAtNode(this.el);
    },

    render: function() {
        renderAttendeeLogin(
            {
                screen: LoginWidgetScreen.profile,
                closable: false,
                isShownByDefault: true,
                onNotifyProfileChanged: profile => {
                    this.model.set(profile);
                    this.model.set('joinedNow', true);
                    if (this.model.noJoin) {
                        this.model.set({ isJoined: true });
                        this.trigger('back');
                    } else {
                        this.model.join(this.event.id, {
                            success() {
                                this.trigger('back');
                            },
                        });
                    }
                    this.remove();
                }
            },
            this.el
        );

        return this;
    },
});
_.extend(SignUpView.prototype, FormViewMixin);

export default SignUpView;
